// Pre-filled forms for links like /contact?topic=accessibility. Topics are a
// fixed whitelist so a crafted URL can't put arbitrary text in the form.
export const CONTACT_TOPICS = {
  accessibility: {
    heading: "Report an accessibility issue",
    intro:
      "Something on this site hard to use with a keyboard, screen reader, zoom, or anything else? Tell me what happened and I'll fix it.",
    subject: "Accessibility issue",
    body: [
      "Page or link:",
      "",
      "What happened:",
      "",
      "What you were using (browser, assistive technology), if relevant:",
      "",
    ].join("\n"),
  },
} as const;

export type ContactTopic = keyof typeof CONTACT_TOPICS;
